import { Suspense, lazy } from 'react';
import Topbar from '../components/Topbar';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Hero from '../components/sections/Hero';
import siteData from '../siteData.json';

function Home() {
  return (
    <div className="home">
      <Topbar />
      <Navbar />
      <main className="main">
        <Hero />
        {siteData.sections.map((section, i) => {
          const SectionComponent = lazy(() => import(`../components/sections/${section}`));
          return (
            <Suspense key={i}>
              <SectionComponent />
            </Suspense>
          );
        })}
      </main>
      <Footer />
    </div>
  );
}

export default Home;
